// extracted by mini-css-extract-plugin
export default {"EditProfile":"EditProfile_EditProfile__EVZP2","form":"EditProfile_form__AsWCJ","userImage":"EditProfile_userImage__Hai8P"};